type Props = {
  name: string;
  fullAddress: string;
  merchantName?: string;
};

export const PosInfo = ({ name, fullAddress, merchantName }: Props) => (
  <div className="max-w-full">
    <div>{name}</div>
    {!!merchantName && (
      <div className="text-sm text-gray-500">{merchantName}</div>
    )}
    <div
      className={`
        max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm
        text-gray-500
      `}
      title={fullAddress}
    >
      {fullAddress}
    </div>
  </div>
);
